import { gql, useMutation } from '@apollo/client';

const useDeleteMeMutation = (options) =>
    useMutation(
        gql`
            mutation DeleteMeMutation {
                deleteMe
            }
        `,
        {
            update: (cache) =>
                cache.writeQuery({
                    query: gql`
                        query MeQuery {
                            me
                        }
                    `,
                    data: { me: null },
                }),
            ...options,
        }
    );

export { useDeleteMeMutation };
